import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { QueryProvider } from "./lib/queryClient.tsx";
import { ThemeProvider } from "next-themes";
import { initializeNotifications } from "./lib/notifications";
import { AuthProvider } from "./contexts/AuthContext";
import { ProjectsProvider } from "./contexts/ProjectsContext";
import { TaskDialogProvider } from "./contexts/TaskDialogContext";
import { TimerProvider } from "./contexts/TimerContext";

// Service worker is auto-registered by vite-plugin-pwa with registerType: 'autoUpdate'
// No manual registration needed

// Initialize daily notifications
initializeNotifications();

// PostHog is disabled
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <QueryProvider>
        <AuthProvider>
          <ProjectsProvider>
            <TimerProvider>
              <TaskDialogProvider>
                <App />
              </TaskDialogProvider>
            </TimerProvider>
          </ProjectsProvider>
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  </StrictMode>,
);